import React, { useEffect, useState } from 'react';
import { sendApiRequest } from '../../../api/request';
import './logsPage.css';

const SORT_OPTIONS = ['latest', 'oldest', 'actions', 'sessions', 'mobile'];

const LogsPage = () => {
  const [sessions, setSessions] = useState([]);
  const [actions, setActions] = useState([]);
  const [mergedLogs, setMergedLogs] = useState([]);
  const [sortOption, setSortOption] = useState('latest');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [sessionData, actionData] = await Promise.all([
          sendApiRequest('GET', '/visitor/session'),
          sendApiRequest('GET', '/visitor/action'),
        ]);
        setSessions(sessionData);
        setActions(actionData);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const logs = [
      ...sessions.map((s) => ({ ...s, type: 'session', time: s.startTime })),
      ...actions.map((a) => ({ ...a, type: 'action', time: a.actionTime })),
    ];
    setMergedLogs(logs);
  }, [sessions, actions]);

  const sortedLogs = [...mergedLogs].sort((a, b) => {
    switch (sortOption) {
      case 'latest':
        return new Date(b.time) - new Date(a.time);
      case 'oldest':
        return new Date(a.time) - new Date(b.time);
      case 'actions':
        return a.type === 'action' && b.type !== 'action' ? -1 : 1;
      case 'sessions':
        return a.type === 'session' && b.type !== 'session' ? -1 : 1;
      case 'mobile':
        return a.isMobile && !b.isMobile ? -1 : 1;
      default:
        return 0;
    }
  });

  const totalPages = Math.ceil(sortedLogs.length / itemsPerPage);
  const pagedLogs = sortedLogs.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const renderCell = (log, key) => {
    if (typeof log[key] === 'object' && log[key] !== null) {
      return JSON.stringify(log[key]);
    }
    return log[key]?.toString();
  };

  return (
    <div className="logs-page-container">
      <h2 className="logs-page-title">Visitor Logs</h2>

      <div className="logs-page-controls">
        <div className="logs-page-sort">
          <label>Sort by:</label>
          <select
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
          >
            {SORT_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>
                {opt.charAt(0).toUpperCase() + opt.slice(1)}
              </option>
            ))}
          </select>
        </div>
        <div className="logs-page-items">
          <label>Items per page:</label>
          <input
            type="number"
            value={itemsPerPage}
            min={1}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          />
        </div>
      </div>

      <div className="logs-table-wrapper">
        <table className="logs-table">
          <thead>
            <tr>
              {pagedLogs[0] &&
                Object.keys(pagedLogs[0]).map((col) => (
                  <th key={col}>{col.replace(/_/g, ' ').toUpperCase()}</th>
                ))}
            </tr>
          </thead>
          <tbody>
            {pagedLogs.map((log, idx) => (
              <tr key={idx}>
                {Object.keys(log).map((key) => (
                  <td key={key}>{renderCell(log, key)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="logs-page-pagination">
        <button
          disabled={currentPage <= 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          disabled={currentPage >= totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default LogsPage;
